// extracted by mini-css-extract-plugin
module.exports = {"newsroom-banner-box":"g","newsroomBannerBox":"g","newsroomBannerLeft":"h","newsroomBannerRight":"i"};